import React, { FC, useState } from "react";
import { Table } from "../Table";
import ColumnsComponent, {
  dateAppliedCol,
  reasonCol,
} from "./ColumnsComponent";
import { Props } from "./type";

const NewApplicants: FC<Props> = ({
  tableData,
  isLoading,
  onClickApplicant,
  onChange,
  total,
  currentPage,
}) => {
  const [filterDropdown, setFilterDropdownVisible] = useState<any>({
    isVisible: false,
    dropdownKey: "",
  });

  return (
    <Table
      isLoading={isLoading}
      tableData={tableData}
      columns={[
        ...(ColumnsComponent(filterDropdown, setFilterDropdownVisible) as any),
        reasonCol,
        dateAppliedCol,
      ]}
      rowRecord={onClickApplicant}
      onChange={onChange}
      totalItems={total}
      current={currentPage}
    />
  );
};

export default NewApplicants;
